import { Dropdown } from 'antd';
import 'antd/es/dropdown/style/index';
import './index.less';

export default Dropdown;
